import { render, staticRenderFns } from "./CompactCard.vue?vue&type=template&id=d8c015c0&scoped=true&"
import script from "./CompactCard.vue?vue&type=script&lang=js&"
export * from "./CompactCard.vue?vue&type=script&lang=js&"
import style0 from "./CompactCard.vue?vue&type=style&index=0&id=d8c015c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c015c0",
  null
  
)

export default component.exports